/* Kai's retailer locator: independent all-pin map and nearest-first list. */
(function () {
  'use strict';
  if (window.KaiLocatorV3) { window.KaiLocatorV3.init(document); return; }
  var app = { origin: null, autoAttempted: false, mapLibrary: null };
  var zipKey = 'kai-locator-last-zip';
  function text(v) { return String(v == null ? '' : v).trim(); }
  function coordinate(v) { return text(v) ? Number(v) : NaN; }
  function validPoint(lat, lng) { return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180; }
  function alphabetically(a, b) { return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }); }
  function miles(a, b) {
    var r = Math.PI / 180;
    var h = Math.pow(Math.sin((b.lat - a.lat) * r / 2), 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.pow(Math.sin((b.lng - a.lng) * r / 2), 2);
    h = Math.max(0, Math.min(1, h));
    return 7917.6 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }
  function mileage(n) { return n.toFixed(n < 10 ? 1 : 0); }
  function lastZip() { try { return sessionStorage.getItem(zipKey) || ''; } catch (e) { return ''; } }
  function rememberZip(zip) { try { if (zip) sessionStorage.setItem(zipKey, zip); else sessionStorage.removeItem(zipKey); } catch (e) { /* Storage is optional. */ } }
  function safeURL(value) { try { var u = new URL(value, location.origin); return /^https?:$/.test(u.protocol) ? u.href : ''; } catch (e) { return ''; } }
  function loadAsset(url, css, integrity) {
    return new Promise(function (resolve, reject) {
      var el = document.createElement(css ? 'link' : 'script');
      var done = false;
      var timeout = setTimeout(function () { finish(false); }, 8000);
      function finish(ok) {
        if (done) return;
        done = true; clearTimeout(timeout); el.onload = null; el.onerror = null;
        if (ok) resolve(); else { el.remove(); reject(new Error('Map resource could not load.')); }
      }
      if (css) { el.rel = 'stylesheet'; el.href = url; } else { el.async = true; el.src = url; }
      if (integrity) { el.integrity = integrity; el.crossOrigin = 'anonymous'; }
      el.onload = function () { finish(true); };
      el.onerror = function () { finish(false); };
      document.head.appendChild(el);
    });
  }
  function mapLibrary() {
    if (app.mapLibrary) return app.mapLibrary;
    var jsHash = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    var cssHash = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
    function attempt(base) {
      return Promise.all([
        loadAsset(base + 'leaflet.css', true, cssHash),
        window.L && window.L.map ? Promise.resolve() : loadAsset(base + 'leaflet.js', false, jsHash)
      ]).then(function () { if (!window.L || !window.L.map) throw new Error('Map library not ready.'); return window.L; });
    }
    app.mapLibrary = attempt('https://unpkg.com/leaflet@1.9.4/dist/').catch(function () {
      return attempt('https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/');
    }).catch(function (error) { app.mapLibrary = null; throw error; });
    return app.mapLibrary;
  }
  function init(root) {
    if (root.dataset.locatorReady === 'v3') return;
    var list = root.querySelector('[data-card-list]');
    var status = root.querySelector('[data-status]');
    var heading = root.querySelector('[data-results-heading]');
    var form = root.querySelector('[data-zip-form]');
    var zipInput = root.querySelector('[data-zip-input]');
    var zipButton = form && form.querySelector('button[type="submit"]');
    var locationButton = root.querySelector('[data-use-location]');
    var locationLabel = root.querySelector('[data-location-label]');
    var sort = root.querySelector('[data-sort-order]');
    var sortHint = root.querySelector('[data-sort-hint]');
    var mapEl = root.querySelector('[data-retailer-map]');
    var mapLabel = root.querySelector('[data-map-label]');
    var mapNote = root.querySelector('[data-map-note]');
    var mapError = root.querySelector('[data-map-error]');
    var mapErrorText = root.querySelector('[data-map-error-text]');
    var mapRetry = root.querySelector('[data-map-retry]');
    var mapAll = root.querySelector('[data-map-all]');
    var fallback = root.querySelector('[data-fallback-map]');
    var mapLink = root.querySelector('[data-map-link]');
    var previewLink = root.querySelector('[data-preview-link]');
    if (!list || !status || !form || !zipButton || !locationButton || !sort || !mapEl) return;
    var stores = Array.prototype.map.call(root.querySelectorAll('[data-retailer]'), function (card) {
      var directions = card.querySelector('.kai-retailer__primary');
      return { card: card, name: text(card.dataset.name), address: text(card.dataset.address), lat: coordinate(card.dataset.lat), lng: coordinate(card.dataset.lng), directions: directions ? safeURL(directions.href) : '', distance: Infinity, marker: null, rank: 0 };
    });
    var mapped = stores.filter(function (s) { return validPoint(s.lat, s.lng); });
    var origin = app.origin;
    var selected = null;
    var nearest = null;
    var map = null;
    var group = null;
    var tiles = null;
    var mapFailed = false;
    var startingMap = false;
    var disposed = false;
    var observer = null;
    var tileTimer = null;
    var sequence = 0;
    var timer = null;
    var controller = null;
    var normalZipText = text(zipButton.textContent);
    var normalLocationText = text(locationLabel.textContent);
    var embedded = window.self !== window.top;
    var autoTimer = null;
    root.dataset.locatorReady = 'v3';
    if (previewLink) previewLink.href = window.location.href;
    function message(value, error) { status.textContent = value; status.classList.toggle('is-error', Boolean(error)); }
    function buttonsReady() {
      locationButton.disabled = false; locationButton.removeAttribute('aria-busy'); locationLabel.textContent = normalLocationText;
      zipButton.disabled = false; zipButton.removeAttribute('aria-busy'); zipButton.textContent = normalZipText;
    }
    function cancel() {
      sequence++; clearTimeout(timer); timer = null;
      if (controller) controller.abort(); controller = null; buttonsReady();
      if (previewLink) previewLink.hidden = true;
      return sequence;
    }
    function active(token) { return !disposed && root.isConnected && token === sequence; }
    function finish(token) { if (!active(token)) return false; clearTimeout(timer); timer = null; controller = null; sequence++; buttonsReady(); return true; }
    function locationError(reason) {
      message(reason + (origin ? ' Previous distance results remain available.' : ' Showing all stores A-Z for now. Enter a ZIP code to sort by distance.'), true);
    }
    function popup(store) {
      var box = document.createElement('div'); box.className = 'kai-map-popup';
      var title = document.createElement('strong'); title.textContent = store.name; box.appendChild(title);
      var address = document.createElement('p'); address.textContent = store.address; box.appendChild(address);
      if (Number.isFinite(store.distance)) { var distance = document.createElement('p'); distance.textContent = (store === nearest ? 'Closest retailer. ' : '') + 'About ' + mileage(store.distance) + ' miles away (straight-line).'; box.appendChild(distance); }
      if (store.directions) { var link = document.createElement('a'); link.href = store.directions; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.textContent = 'Get directions'; box.appendChild(link); }
      return box;
    }
    function pin(store) {
      return window.L.divIcon({ className: 'kai-map-marker' + (store === nearest ? ' kai-map-marker--nearest' : ''), html: '<span class="kai-map-marker__dot"><b>' + store.rank + '</b></span>', iconSize: [40, 40], iconAnchor: [20, 30], popupAnchor: [0, -26] });
    }
    function decorateMarkers() {
      stores.forEach(function (store) {
        if (!store.marker) return;
        store.marker.setIcon(pin(store)); store.marker.setPopupContent(popup(store));
        var el = store.marker.getElement();
        if (el) el.setAttribute('aria-label', 'Pin ' + store.rank + ': ' + store.name + (store === nearest ? ', closest retailer' : ''));
      });
    }
    function renderList() {
      stores.forEach(function (s) { s.distance = origin && validPoint(s.lat, s.lng) ? miles(origin, s) : Infinity; });
      nearest = mapped.slice().sort(function (a, b) { return (a.distance - b.distance) || alphabetically(a, b); }).find(function (s) { return Number.isFinite(s.distance); }) || null;
      stores.sort(sort.value === 'distance' && origin ? function (a, b) { return (a.distance - b.distance) || alphabetically(a, b); } : alphabetically);
      stores.forEach(function (store, i) {
        store.rank = i + 1;
        store.card.classList.toggle('is-nearest', store === nearest);
        var rank = store.card.querySelector('[data-store-rank]'); if (rank) rank.textContent = store.rank;
        var d = store.card.querySelector('[data-distance]');
        if (d) { d.hidden = !Number.isFinite(store.distance); d.textContent = d.hidden ? '' : (store === nearest ? 'Closest \u00b7 ' : '') + 'About ' + mileage(store.distance) + ' miles away (straight-line)'; }
        list.appendChild(store.card);
      });
      var waiting = sort.value === 'distance' && !origin;
      heading.textContent = sort.value === 'distance' && origin ? 'Nearest locations' : 'All locations';
      if (sortHint) sortHint.hidden = !waiting;
      root.dataset.sortState = waiting ? 'awaiting-location' : sort.value;
      decorateMarkers();
    }
    function sortedMessage() {
      if (sort.value === 'distance' && nearest) message('Closest to ' + origin.label + ': ' + nearest.name + '. All ' + stores.length + ' retailers are listed nearest first. Distances are approximate, straight-line miles, not driving miles.');
      else if (sort.value === 'distance' && !origin) message('Allow location access or enter a ZIP code to sort nearest first. All ' + stores.length + ' retailers are shown A-Z until a location is available.');
      else if (sort.value === 'distance') message('No mapped retailers are available for distance sorting. Store contact details are still listed below.');
      else message('All ' + stores.length + ' retailers listed A-Z.' + (origin ? ' Distances are from ' + origin.label + '.' : ''));
    }
    function updateSelection() {
      stores.forEach(function (s) { s.card.classList.toggle('is-selected', s === selected); var button = s.card.querySelector('[data-show-store]'); if (button) button.setAttribute('aria-pressed', s === selected ? 'true' : 'false'); });
      mapAll.disabled = !selected;
      mapLabel.textContent = selected ? selected.name : (mapped.length === stores.length ? 'All ' + mapped.length + ' retailer locations' : mapped.length + ' of ' + stores.length + ' retailers mapped');
      mapNote.textContent = selected ? 'Showing the selected store. Use Show all stores to see every pin again.' : 'Select a pin or a store below to focus the map.';
      mapLink.hidden = !selected;
      if (selected) { mapLink.href = selected.directions || 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(selected.name + ', ' + selected.address); mapLink.textContent = 'Open ' + selected.name + ' in Google Maps'; }
      root.dataset.mapMode = selected ? 'selected' : 'all';
    }
    function fitAll() {
      if (!map || !mapped.length) return;
      if (mapped.length === 1) map.setView([mapped[0].lat, mapped[0].lng], 12, { animate: false });
      else map.fitBounds(mapped.map(function (s) { return [s.lat, s.lng]; }), { padding: [38, 42], maxZoom: 11, animate: false });
    }
    function applyMapView() {
      updateSelection();
      if (map) {
        map.closePopup(); group.clearLayers();
        (selected && selected.marker ? [selected] : mapped).forEach(function (s) { group.addLayer(s.marker); });
        mapEl.hidden = false; fallback.hidden = true;
        if (selected && selected.marker) { map.setView([selected.lat, selected.lng], 13, { animate: false }); selected.marker.setPopupContent(popup(selected)); selected.marker.openPopup(); }
        else fitAll();
        decorateMarkers();
        root.dataset.visiblePins = String(selected && selected.marker ? 1 : mapped.length);
      }
      if (selected && (!validPoint(selected.lat, selected.lng) || mapFailed)) {
        fallback.src = 'https://www.google.com/maps?q=' + encodeURIComponent(selected.name + ', ' + selected.address) + '&z=13&output=embed';
        fallback.title = 'Google map showing ' + selected.name; fallback.hidden = false; mapEl.hidden = true;
        root.dataset.visiblePins = '0';
      } else if (mapFailed) { fallback.hidden = true; mapEl.hidden = true; }
    }
    function chooseStore(store) { selected = store; applyMapView(); }
    function showAll() { selected = null; applyMapView(); }
    function mapProblem(value) { mapErrorText.textContent = value; mapError.hidden = false; }
    function startMap() {
      if (startingMap || disposed) return;
      if (!mapped.length) { mapEl.hidden = true; mapProblem('No map coordinates are available yet. Store details and directions are listed below.'); mapRetry.hidden = true; return; }
      startingMap = true; mapFailed = false; mapError.hidden = true;
      mapEl.hidden = false; mapEl.textContent = 'Loading retailer map...'; mapEl.setAttribute('aria-busy', 'true');
      mapLibrary().then(function (L) {
        if (disposed || !root.isConnected) return;
        mapEl.textContent = '';
        map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true, zoomSnap: 0.25, minZoom: 3, maxZoom: 18 });
        // Ordinary visible-map requests only: no tile prefetch or cache-busting.
        tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap contributors</a>', referrerPolicy: 'strict-origin-when-cross-origin' });
        var successes = 0; var failures = 0;
        function tileStatus() { if (!disposed && failures && !successes) mapProblem('The map background could not load. Store pins and distance search still work; use Get directions to open Google Maps.'); }
        tiles.on('loading', function () { successes = 0; failures = 0; clearTimeout(tileTimer); tileTimer = setTimeout(tileStatus, 9000); });
        tiles.on('tileload', function () { successes++; mapError.hidden = true; });
        tiles.on('tileerror', function () { failures++; });
        tiles.on('load', function () { clearTimeout(tileTimer); tileStatus(); });
        tiles.addTo(map); group = L.layerGroup().addTo(map);
        mapped.forEach(function (store) {
          store.marker = L.marker([store.lat, store.lng], { icon: pin(store), title: store.name, keyboard: true });
          store.marker.bindPopup(popup(store), { maxWidth: 245 });
          var tip = document.createElement('span'); tip.textContent = store.name;
          store.marker.bindTooltip(tip, { direction: 'top', offset: [0, -25] });
          store.marker.on('click', function () { chooseStore(store); });
        });
        mapEl.removeAttribute('aria-busy'); root.dataset.mapReady = 'true'; applyMapView();
        if (typeof ResizeObserver !== 'undefined') {
          observer = new ResizeObserver(function () { if (!map || disposed) return; map.invalidateSize({ pan: false }); if (!selected) fitAll(); });
          observer.observe(mapEl);
        }
      }).catch(function () {
        if (disposed) return;
        if (map) { map.remove(); map = null; group = null; }
        mapFailed = true; mapEl.removeAttribute('aria-busy'); mapEl.hidden = true; root.dataset.mapReady = 'false';
        mapProblem('The interactive map could not load. Select a store to view its Google map, or use the directions buttons.'); applyMapView();
      }).then(function () { startingMap = false; });
    }
    function useOrigin(value, zip) {
      if (!validPoint(value.lat, value.lng)) { locationError('We could not determine that location.'); return; }
      origin = value; app.origin = value; rememberZip(zip || ''); sort.value = 'distance'; renderList(); sortedMessage();
      // Sorting must not select the closest pin or discard an explicit selection.
    }
    function lookupZip(value) {
      var token = cancel();
      if (!/^\d{5}(?:-\d{4})?$/.test(text(value))) { message('Enter a valid 5-digit US ZIP code.', true); zipInput.focus(); return; }
      var zip = text(value).slice(0, 5); zipInput.value = zip;
      zipButton.disabled = true; zipButton.setAttribute('aria-busy', 'true'); zipButton.textContent = 'Searching...';
      message('Finding retailers nearest ZIP ' + zip + '...');
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null; var thisController = controller;
      timer = setTimeout(function () { if (!finish(token)) return; if (thisController) thisController.abort(); locationError('ZIP lookup timed out. Please try again.'); }, 12000);
      Promise.resolve().then(function () { return fetch('https://api.zippopotam.us/us/' + zip, { credentials: 'omit', signal: thisController ? thisController.signal : undefined }); })
        .then(function (r) { if (r.status === 404) throw new Error('zip-not-found'); if (!r.ok) throw new Error('lookup-unavailable'); return r.json(); })
        .then(function (data) { var p = data.places && data.places[0]; if (!p || !validPoint(coordinate(p.latitude), coordinate(p.longitude))) throw new Error('zip-not-found'); if (finish(token)) useOrigin({ lat: coordinate(p.latitude), lng: coordinate(p.longitude), label: 'ZIP ' + zip }, zip); })
        .catch(function (e) { if (finish(token)) locationError(e.message === 'zip-not-found' ? 'That ZIP code was not found.' : 'ZIP lookup is temporarily unavailable.'); });
    }
    function useLocation() {
      var token = cancel();
      if (window.isSecureContext === false) { locationError('Location requires a secure HTTPS page.'); return; }
      if (!navigator.geolocation) { locationError('This browser does not support location access.'); return; }
      var policy = document.permissionsPolicy || document.featurePolicy;
      try {
        if (policy && typeof policy.allowsFeature === 'function' && !policy.allowsFeature('geolocation')) { locationError('Location is blocked in this preview. Open the locator in a new tab or search by ZIP.'); if (previewLink) previewLink.hidden = false; return; }
      } catch (e) { /* Some browsers do not expose permissions policy. */ }
      locationButton.disabled = true; locationButton.setAttribute('aria-busy', 'true'); locationLabel.textContent = 'Getting your location...';
      message('Allow location access to put the nearest stores first, or enter a ZIP code. All retailer pins remain visible until you select a store.');
      timer = setTimeout(function () { if (finish(token)) { locationError('Location lookup timed out.'); if (embedded && previewLink) previewLink.hidden = false; } }, 15000);
      try {
        navigator.geolocation.getCurrentPosition(function (position) { if (finish(token)) useOrigin({ lat: position.coords.latitude, lng: position.coords.longitude, label: 'your location' }); }, function (error) {
          if (!finish(token)) return;
          locationError(error.code === 1 ? 'Location access was not allowed.' : error.code === 3 ? 'Location lookup timed out.' : 'Your device could not determine its location.');
          if (embedded && previewLink) previewLink.hidden = false;
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
      } catch (error) { if (finish(token)) locationError('Location access could not start.'); }
    }
    form.addEventListener('submit', function (event) { event.preventDefault(); lookupZip(zipInput.value); });
    locationButton.addEventListener('click', useLocation);
    sort.addEventListener('change', function () { cancel(); renderList(); sortedMessage(); if (sort.value === 'distance' && !origin) { if (/^\d{5}$/.test(text(zipInput.value))) lookupZip(zipInput.value); else useLocation(); } });
    mapAll.addEventListener('click', showAll);
    mapRetry.addEventListener('click', function () { if (map && tiles) { mapError.hidden = true; tiles.redraw(); } else startMap(); });
    stores.forEach(function (store) {
      store.card.addEventListener('click', function (event) {
        if (event.target.closest('[data-show-store]') || !event.target.closest('a, button, input, select, textarea')) chooseStore(store);
      });
    });
    root.kaiLocatorCleanup = function () { disposed = true; cancel(); clearTimeout(autoTimer); clearTimeout(tileTimer); if (observer) observer.disconnect(); if (map) { map.remove(); map = null; } };
    sort.value = 'distance'; renderList(); sortedMessage(); showAll(); startMap();
    var initialToken = sequence;
    autoTimer = setTimeout(function () {
      if (!active(initialToken) || origin || !stores.length || sort.value !== 'distance') return;
      var cached = lastZip(); if (/^\d{5}$/.test(cached)) { lookupZip(cached); return; }
      if (root.dataset.designMode === 'true' || (window.Shopify && window.Shopify.designMode)) return;
      if (!app.autoAttempted) { app.autoAttempted = true; useLocation(); }
    }, 0);
  }
  function roots(scope) { var found = Array.prototype.slice.call(scope.querySelectorAll('[data-kai-locator-v3]')); if (scope.matches && scope.matches('[data-kai-locator-v3]')) found.unshift(scope); return found; }
  function initAll(scope) { roots(scope).forEach(init); }
  app.init = initAll; window.KaiLocatorV3 = app; initAll(document);
  document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { roots(e.target).forEach(function (root) { if (root.kaiLocatorCleanup) root.kaiLocatorCleanup(); }); });
})();
